// NotAuthorized.tsx
import React from 'react';
const NotAuthorized = () => {
    return (React.createElement("div", null,
        React.createElement("h1", null, "Not Authorized"),
        React.createElement("p", null, "You do not have permission to view this page.")));
};
export default NotAuthorized;
